module.exports = __webpack_public_path__ + "static/media/contract_uav_gc.97239c3b.svg";